<template>
  <div class='oversea full_layout' v-loading.fullscreen="disabled">
    <div><img src="/static/images/activty/purchasehistory/purchase/PurchaseHistory_01.jpg"></div>
    <div><img src="/static/images/activty/purchasehistory/purchase/PurchaseHistory_02.jpg"></div>
    <div><img src="/static/images/activty/purchasehistory/purchase/PurchaseHistory_03.jpg"></div>
    <div><img src="/static/images/activty/purchasehistory/purchase/PurchaseHistory_04.jpg"></div>
    <div><img src="/static/images/activty/purchasehistory/purchase/PurchaseHistory_05.jpg"></div>
    <div><img src="/static/images/activty/purchasehistory/purchase/PurchaseHistory_06.jpg"><span @click="ShippingFee"></span></div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  data() {
    return {
      disabled:false
    }
  },
  watch: {
  },
  mounted() {},
  created() {
    this.$store.commit('SET_HEADER_TITLE', this.$t('title.processIntroduction'));
  },
  methods: {
    ShippingFee() {
      // 价格列表
      let that = this

          this.$router.push({
            path: '/terms/process'
          })
      // this.$confirm(html, '', {
      //     confirmButtonText: 'Yes',
      //     cancelButtonText: '',
      //     customClass: "confirmBox",
      //     lockScroll: false,
      //     dangerouslyUseHTMLString: true
      //   }).then(() => {
      //     //this.setOrder(obj)
      //   }).catch(() => {});
    },
  },
}

</script>
<style scoped>
.oversea{
  margin-top: 24px;
}
.oversea img{
  width: 100%;
  display: block;
  overflow: hidden;
}
.oversea>div{
  position: relative;
}
.oversea>div>span{
  position: absolute;
width: 203px;
    height: 34px;
    bottom: 167px;
    right: 367px;
    cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/purchase.vue